import { render, staticRenderFns } from "./AddNarrative.vue?vue&type=template&id=e8d39d72"
import script from "./AddNarrative.vue?vue&type=script&lang=js"
export * from "./AddNarrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports